import { Injectable } from '@angular/core';
import { NativeGeocoder, ReverseOptions } from '@capgo/nativegeocoder';
import { MSLatLng } from '../models/map.model';

@Injectable({
  providedIn: 'root'
})
export class GeocoderService {
  constructor() {}

  async isSameAddress(location: MSLatLng, otherLocation: MSLatLng): Promise<boolean> {
    const placeOptions: ReverseOptions = {
      latitude: location.lat,
      longitude: location.lng
    };
    const otherPlaceOptions: ReverseOptions = {
      latitude: otherLocation.lat,
      longitude: otherLocation.lng
    };

    const addressPossiblities = await NativeGeocoder.reverseGeocode(placeOptions);
    const otherAddressPossibilities = await NativeGeocoder.reverseGeocode(otherPlaceOptions);

    for (const address of addressPossiblities.addresses) {
      for (const otherAddress of otherAddressPossibilities.addresses) {
        if (address.latitude === otherAddress.latitude && address.longitude === otherAddress.longitude) {
          return true;
        }
      }
    }

    return false;
  }
}
